<template>
  <div v-if="checkValue" class="attributes-list__item">
    <template v-if="isArray(value) && value.length">
      <div class="attributes-list__label">{{ normalizedLabel }}</div>
      <div v-for="(val, key) in value" :key="key" class="attributes-list__field">
        {{ val }}
      </div>
    </template>
    <template v-else>
      <div class="attributes-list__label">{{ normalizedLabel }}</div>
      <div class="attributes-list__field">{{ value }}</div>
    </template>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import startCase from 'lodash/startCase';
import isArray from 'lodash/isArray';

export default {
  name: 'ShowAttribute',
  props: ['label', 'value'],
  computed: {
    checkValue() {
      return !isNil(this.value);
    },
    normalizedLabel() {
      if (this.label) {
        return startCase(this.label).toLowerCase();
      }
      return '';
    }
  },
  methods: {
    isArray
  }
};
</script>
